import Customer from './customer.endpoint.constants';
import OilSample from './oil-sample.endpoint.constants';
import CoolantSample from './coolant-sample.endpoint.constants';
import Unit from './unit.endpoint.constants';

export default {
  CoolantSample,
  Customer,
  OilSample,
  Unit
};
